/**
 * @description: 业绩系数设置
 * @author: lyr
 */
<template>
	<div class="performance-set-wrapper">
		<div class="performance-list" v-show="showList">
            <div class="red-tip">业绩系数：应用于营销员工业绩报表中超出业绩的核算，超出业绩=（实收金额-业绩核算低消金额）*业绩系数</div>
            <el-form :inline="true">
				<el-form-item label="门店">
                    <el-select v-model="shop_id" filterable @change="onShopChange">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item>
					<el-button type="primary" @click="listQuery">查询</el-button>
					<el-button type="primary" @click="toAdd">新增业绩系数</el-button>
				</el-form-item>
			</el-form>
            <el-table
				v-loading="loading"
    			element-loading-text="努力加载中，请稍后..."
				element-loading-background="rgba(0, 0, 0, 0.6)"
				:data="list_table">
				<el-table-column prop="listorder" label="优先级"></el-table-column>
				<el-table-column prop="room_name_str" label="适用包厢"></el-table-column>
				<el-table-column prop="coefficient" label="业绩系数"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
                        <span class="text-blue" @click="toModify(scope.row)">修改</span>
						<span class="text-blue" @click="deleteThis(scope.row.id)">删除</span>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="total, prev, pager, next, jumper"
				:page-size="GLOBAL.PAGESIZE"
				:current-page.sync="list_page"
				:total="list_total"
				@current-change="getListTable">
			</el-pagination>
		</div>

		<!-- 新增、修改规则面板 -->
		<div class="add-panel" v-show="!showList&&!showRoomPanel">
			<h1>{{isModify?'修改业绩系数':'新增业绩系数'}}</h1>
			<el-form v-model="add_form" label-width="210px">
                <el-form-item label="门店">
                    <el-select v-model="add_form.shop_id" placeholder="请选择门店" disabled>
				      	<el-option :label="item.name" :value="item.id" :key="item.id" v-for="item in shop_list"></el-option>
				    </el-select>
                </el-form-item>
               	<el-form-item label="优先级">
                    <el-input v-model="add_form.listorder" placeholder="请输入优先级，数值大的优先"></el-input>
                </el-form-item>
                <el-form-item label="适用包厢">
                    <el-input v-model="add_form.room_ids_str" placeholder="请选择适用包厢" readonly @click.native="openRoomPanel"></el-input>
                </el-form-item>
                <el-form-item label="业绩系数">
                    <el-input v-model="add_form.coefficient" placeholder="请输入业绩系数"></el-input>
                </el-form-item>
				<el-form-item>
                    <el-button @click="backToList">取消</el-button>
                    <el-button type="primary" @click="commitSet">确定</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 适用包厢面板 -->
		<div class="rooms-panel" v-show="showRoomPanel">
			<h3>选择适用包厢</h3>
			<div class="row">
				<el-radio-group v-model="roomShowType" @change="onRoomShowTypeChange">
					<el-radio label="2">按包厢类型显示</el-radio>
					<el-radio label="1">按包厢区域显示</el-radio>
				</el-radio-group>
			</div>
			<div class="room-wrapper">
                <div class="block-title">
                    <el-checkbox v-model="checkAllRoom" @change="handleCheckAllRoomChange">全选</el-checkbox>
                </div>
                <div class="block" v-for="(item,pindex) in room_arr">
                    <div class="block-title">
                        <el-checkbox @change="checked=>handleCheckArea(checked,pindex)" v-model="item.checked">{{item.room_area_name}}</el-checkbox>
                    </div>
                    <el-checkbox-group class="rooms" v-model="choosedRoom">
                        <el-checkbox class="room" 
                        v-for="(room,cindex) in item.room" 
                        :label="room.id" 
                        :key="room.id" 
                        @change="checked=>handleCheckRoom(checked,pindex,cindex)">{{room.name}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div>
            <el-button @click="showRoomPanel=false">返回</el-button>
            <el-button type="primary" @click="commitRoomChoose">确认</el-button>    
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'performance_set',
		data() {
			return {
				showList: true,
				shop_list: [],
                shop_id: '',
                loading: false,
                list_page: 1,
				list_total: 0,
                list_table: [],

                isModify: false,
                add_form: {
                	listorder: '',
                	coefficient: '',
                	shop_id: '',
                	room_ids: [],
                	room_ids_str: '',
                },

                showRoomPanel: false,
                roomShowType: '2', // 1包厢区域 2包厢类型
                room_arr: [], // 包厢列表
                checkAllRoom: false,
                choosedRoom: [],
			}
		},
		mounted: function() {
			new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.shop_id = this.shop_list[0].id
                this.getListTable(1)
            })
		},
		methods: {
			// 获取门店数据
			getShop: function(resolve) {
				const _this = this;

				Vue.axios.post('PublicData/api_getShopListByPurview', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						_this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
                    console.log(err);
					layer.msg('出错啦');
				});
            },

            // 获取包厢
            getRooms: function(shop_id, type) {
                const _this = this;
                Vue.axios.post('Shop/getAllRoomByArea', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "shop_id": shop_id,
                            "type": type
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.room_arr = res.data.response.result;
                        // if (needFormate) {// 需格式化包厢号
                        	_this.formatChoosedRoom(_this.add_form.room_ids)
                        // }
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

			// 列表
			getListTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Room/getPerformanceCoefficient', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
							"shop_id": _this.shop_id
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count);
						}
						
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

			// 切换门店
			onShopChange(val) {
				this.list_page = 1
				this.getListTable(this.list_page)
			},

			// 查询
			listQuery() {
				this.getListTable(1);
            },

            // 删除
            deleteThis(id) {
            	const _this = this;

				layer.confirm('删除后不可恢复，确定删除吗？', {
					btn: ['确定', '取消']
				}, function() {
					Vue.axios.post('Room/delPerformanceCoefficient', {
						"header": Vue.request_header,
						"request": {
							"version": Vue.version,
							"param": {
                                "id": id
							}
						},
						"comment": ""
					})
					.then(res => {
						if(res.data.response.result_code == "true") {
							layer.msg('删除成功');
							_this.getListTable(_this.list_page);
						} else {
							Vue.timeoutfun(res.data.response.result_status, _this);
							layer.msg(res.data.response.error_msg);
						}
					})
					.catch(err => {
						layer.msg('出错啦');
					});
				});
            },

            // 点击“新增”
            toAdd() {
            	this.add_form = {
            		shop_id: this.shop_id,
            		listorder: '',
            		room_ids: [],
            		room_ids_str: '',
            		coefficient: ''
            	}
            	this.isModify = false
            	this.showList = false
            	this.checkAllRoom = false
                this.choosedRoom = []
                this.roomShowType = '2' // 默认按照包厢类型显示
                this.getRooms(this.shop_id, this.roomShowType)
            },

            // 点击“修改”
            toModify(row) {
            	this.add_form = {
            		id: row.id,
            		shop_id: this.shop_id,
            		listorder: row.listorder,
            		room_ids: row.room_ids,
            		room_ids_str: '',
            		coefficient: row.coefficient
            	}
            	this.isModify = true
            	this.showList = false
            	this.checkAllRoom = false
                this.choosedRoom = row.room_ids
                this.roomShowType = '2' // 默认按照包厢类型显示
                this.getRooms(this.shop_id, this.roomShowType)
            },

            openRoomPanel() {
            	this.showRoomPanel = true
            },

            // 切换包厢显示类型
            onRoomShowTypeChange(val) { 
            	this.getRooms(this.shop_id, val)
            },

            // 格式化已选择包厢
            formatChoosedRoom(ids) {
                this.choosedRoom = ids
                this.checkAllRoom = false
                let choosedRoomName = []
                
                if (ids.length > 0) { // 判断区域全选状态
                    this.room_arr.forEach((item, pindex) => {
                        item.choosedCount = 0
                        this.room_arr[pindex].checked = false
                        item.room.forEach((room, cindex) => {
                            ids.forEach(v => {
                                if (v == room.id) {
                                    item.choosedCount ++
                                    choosedRoomName.push(room.name)
                                }
                            })
                        })
                        if (item.choosedCount == item.room.length) {
                            this.room_arr[pindex].checked = true
                        }
                    })
                    this.add_form.room_ids_str = choosedRoomName.join(",")
                }
                this.is_allChoosed()
            },

            // 选择/取消某个区域
            handleCheckArea(val, pindex) {
                if (val) {
                    this.room_arr[pindex].room.forEach(item => {
                        let cindex = this.choosedRoom.findIndex(val => val == item.id)
                        if (cindex < 0) {
                            this.choosedRoom.push(item.id)
                        }
                    })
                    this.is_allChoosed()
                }else {
                    this.room_arr[pindex].room.forEach(item => {
                        let cindex = this.choosedRoom.findIndex(val => val == item.id)
                        if (cindex > -1) {
                            this.choosedRoom.splice(cindex, 1)
                        }
                    })
                    // 取消全选
                    this.checkAllRoom = false
                }
            },

            // 选择/取消某个包厢
            handleCheckRoom(val, pindex, cindex) {
                let areaAllRoom = this.room_arr[pindex].room
                let areaRoomCount = 0
                this.room_arr[pindex].room.forEach(item => {
                    let chooseIndex = this.choosedRoom.findIndex(id => id == item.id)
                    if (chooseIndex > -1) {
                        areaRoomCount ++
                    }
                })
                this.room_arr[pindex].checked = areaRoomCount == areaAllRoom.length

                if (!val) { // 取消全选
                    this.checkAllRoom = false
                }else {
                    this.is_allChoosed()
                }
            },

            // 适用包厢全选
            handleCheckAllRoomChange(val) {
                if (val) {
                    this.room_arr.forEach(item => {
                        item.checked = true
                        item.room.forEach(v => {
                            let cindex = this.choosedRoom.findIndex(val => val == v.id)
                            if (cindex < 0) {
                                this.choosedRoom.push(v.id)
                            }
                        })
                    })
                }else {
                    this.room_arr.forEach(item => {
                        item.checked = false
                    })
                    this.choosedRoom = []
                }
            },

            // 计算是否全选
            is_allChoosed() {
                let count = 0
                this.room_arr.forEach(item => {
                    if (item.checked) {
                        count ++
                    }
                })
                this.checkAllRoom = count == this.room_arr.length
            },

            // 确认选择包厢
            commitRoomChoose() {
            	this.add_form.room_ids = this.choosedRoom
            	if (this.add_form.room_ids.length < 1) {
            		this.add_form.room_ids_str = ''
            	}else {
            		let room_name = []
            		this.add_form.room_ids.forEach(item => {
            			this.room_arr.forEach(parent => {
            				parent.room.forEach(v => {
	            				if (v.id == item) {
	            					room_name.push(v.name)
	            				}
            				})
            			})
            		})
            		this.add_form.room_ids_str = room_name.join(",")
            	}
            	this.showRoomPanel = false
            },

            backToList() {
            	this.showList = true
            },

            // 提交设置
            commitSet() {
                let _this = this;

                Vue.axios.post('Room/editPerformanceCoefficient', {
                    "header": Vue.request_header,
                    "request": {
                        "param": _this.add_form
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                    	if (_this.isModify) {
                        	layer.msg("修改成功！")
                    	}else{
                        	layer.msg("新增成功！")
                    		_this.list_page = 1
                    	}
                    	_this.getListTable(_this.list_page)
                    	_this.showList = true
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
	.red-tip {
		margin-bottom: 10px;
		color: red;
	}

	.add-panel {
		.el-input,
		.el-select {
			width: 500px;
		}
	}

	.rooms-panel {
		h3 {
			margin: 10px 0;
		}
		.room-wrapper {
            margin: 20px 0;
            border: 1px solid #f5f5f5;
            .block-title {
                line-height: 40px;
                background: #f5f5f5;
                padding-left: 20px;
            }
            .block {
                margin-top: 20px;
                .rooms {
                    padding: 10px 20px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;
                    .room {
                        width: 200px;
                        margin: 10px 0;
                    }
                }
            }
        }
	}
</style>